import './SidebarMenu.css';

export const LoadingAnimation = () => {
  return (
    <div className="sidebar-loading-animation">
      <div className="sidebar-loading-animation__dot"></div>
      <div className="sidebar-loading-animation__dot"></div>
      <div className="sidebar-loading-animation__dot"></div>
    </div>
  );
};

